  // eslint-disable-next-line @typescript-eslint/no-unused-vars
import React from 'react';
import { GridFilterModel, GridLogicOperator } from "@mui/x-data-grid";
import { getCookie, setCookie } from "react-use-cookie";
import { SlateResponse } from '../store/types';

const getFilterModel = (key: string) => {
  const lsKey = key;
  const emptyModel = {
    items: [],
    logicOperator: GridLogicOperator.Or,
    quickFilterValues: [],
    quickFilterLogicOperator: GridLogicOperator.Or
  } as GridFilterModel;

  const filterModel = JSON.parse(getCookie(lsKey) || JSON.stringify(emptyModel)) || emptyModel;
  return filterModel; 
};

const updateFilters = (filterModel: GridFilterModel, lsKey: string, selectedSlate: SlateResponse) => {
  const endDate = new Date();
  const startDate = new Date(selectedSlate.startTime);
  const timeDifference = Math.abs(endDate.getTime() - startDate.getTime());
  const daysDifference = Math.ceil(timeDifference / (1000 * 3600 * 24));
  setCookie(lsKey, JSON.stringify(filterModel), { days: daysDifference > 1 ? daysDifference + .25 : 1 });
}

export { getFilterModel, updateFilters };